//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Layout from '@/components/ResponsiveLayout'
import Sidebar from './sidebar'
import { getRelativeDate } from '@/utils/swoop'
import Ticket from './Ticket'

import { mapActions, mapMutations } from 'vuex'

export default {
  components: {
    Layout,
    Sidebar,
    Ticket
  },

  data() {
    return {
      // ticketSearch: [],
      initialStatus: ['Open']
    }
  },

  created() {
    this.resetSidebar()
    this.set(['sidebarTags', this.initialStatus])
  },

  watch: {
    $route: {
      handler: function() {
        if (typeof this.$route.params.id === 'undefined' && !this.isCreating) {
          this.$store.commit('set', ['isSideBarOpen', true])
        } else {
          if (!this.$q.screen.gt.sm) {
            this.$store.commit('set', ['isSideBarOpen', false])
          }
        }
      },
      immediate: true
    }
  },

  computed: {
    isCreating() {
      return this.$route.path === '/support/new'
    },
    routeId() {
      return this.$route.params.id // Current site id
    },
    dateCreated() {
      return getRelativeDate(this.ticket.created_at, true)
    }
  },

  methods: {
    ...mapMutations(['set']),
    ...mapActions(['resetSidebar'])
  }
}
